import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Modal, Form } from 'react-bootstrap';
import { FaCalendarAlt, FaCheckCircle, FaClock, FaTimesCircle, FaEye, FaBan, FaBuilding, FaBox,
  FaMapMarkerAlt, FaUsers, FaParking, FaBed, FaTree, FaGlassCheers, FaPhone, FaEnvelope } from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/customer/dashboard/MyBookings.css';
import CustomerLayout from '../../../../layouts/customer/CustomerLayout';

const packageDetails = {
  diamond: {
    tagline: 'Perfect for Last-Minute Planning',
    priceRange: '₹150,000 - ₹200,000',
    rating: 4.8,
    reviews: 124,
    duration: '8 Hours',
    description: 'Our Day Of Package is designed for couples who have done most of their planning and need professional coordination on their wedding day. We ensure every detail runs smoothly so you can enjoy your special day stress-free.',
    venue: {
      name: 'Pearl Continental Hotel',
      location: 'Clifton Block 5, Karachi',
      type: 'Five Star Hotel',
      capacity: '200-300 guests',
      parking: '500 Cars',
      rooms: '12 Rooms Available',
      garden: 'Outdoor Lawn Area',
      floors: '3 Banquet Halls',
      phone: '+92 21 111 505 505',
      email: 'banquet@pchotels.com',
      description: 'Pearl Continental Karachi is a premier five-star hotel located in the heart of Clifton. The hotel offers world-class banquet facilities with state-of-the-art infrastructure, professional staff, and luxurious settings perfect for weddings.',
      highlights: ['Grand Ballroom capacity 500+', 'Dedicated bridal suite', 'In-house decoration team', 'Halal certified kitchen', 'Backup power generator', 'Valet parking included']
    },
    amenities: ['Free Parking', 'High-Speed WiFi', 'Air Conditioning', 'Heating System', '24/7 Security', 'In-House Catering'],
    includedServices: [
      { title: 'Timeline Creation', description: 'Detailed day-of timeline and schedule' },
      { title: 'On-Site Coordination', description: 'Professional coordinator for 8 hours' },
      { title: 'Basic Catering', description: 'Welcome drinks and light refreshments' },
      { title: 'Sound System', description: 'Professional audio equipment and technician' },
      { title: 'Stage Lighting', description: 'Ambient and stage lighting setup' },
      { title: 'Seating Arrangement', description: 'Elegant seating for all guests' },
      { title: 'Bridal Room', description: 'Private room for bride and groom' },
      { title: 'Venue Decoration', description: 'Simple elegant floral arrangements' }
    ],
    features: ['Unlimited hours on day of event', 'Online planning tools access', '2 coordinating meetings before event', 'Detailed timeline creation', 'Floor plan design and setup', 'Rehearsal coordination', 'Vendor communication management', 'Emergency kit and backup plans'],
  },
  star: {
    tagline: 'Complete Luxury Wedding Experience',
    priceRange: '₹600,000 - ₹800,000',
    rating: 5.0,
    reviews: 198,
    duration: '16 Hours',
    description: 'Our premium Full Service Package offers a completely stress-free planning experience. From your engagement to your wedding day, we handle every detail with perfection.',
    venue: {
      name: 'Grand Marquee Palace',
      location: 'Bahria Town, Karachi',
      type: 'Royal Palace Marquee',
      capacity: '500-1000 guests',
      parking: '2000 Cars',
      rooms: '40 Rooms Available',
      garden: 'Palace Gardens & Pool',
      floors: '4 Exclusive Halls',
      phone: '+92 21 567 8901',
      email: 'palace@grandmarquee.pk',
      description: 'Grand Marquee Palace is Karachi\'s most iconic royal wedding destination in Bahria Town. With its majestic architecture, palatial interiors, and world-class amenities, it is the ultimate venue for couples who desire a truly grand celebration.',
      highlights: ['Royal ballroom for 1000+ guests', 'Multiple themed halls', 'Olympic size outdoor area', 'International cuisine kitchen', 'Helicopter landing pad', 'Celebrity management team']
    },
    amenities: ['Premium Valet', 'Fiber Optic WiFi', 'Climate Control', 'Smart Heating', 'VIP Security', 'International Cuisine'],
    includedServices: [
      { title: 'Complete Planning', description: 'Unlimited meetings and consultations' },
      { title: 'Full Day Coordination', description: 'Team of coordinators for 16 hours' },
      { title: 'Luxury Catering', description: 'Multiple cuisines with live counters' },
      { title: 'Live Band & DJ', description: 'Professional musicians and DJ' },
      { title: 'Designer Lighting', description: 'Custom lighting design and LED walls' },
      { title: 'Premium Furniture', description: 'Luxury seating and lounge areas' },
      { title: 'Presidential Suite', description: 'Luxury suite with full amenities' },
      { title: 'Designer Decoration', description: 'Custom theme with imported flowers' }
    ],
    features: ['Everything included in Partial Service', 'Unlimited planning meetings', 'Attend all vendor meetings', 'Custom wedding website creation', 'Complete RSVP management', '10 designer guest welcome bags', 'Honeymoon planning assistance', 'Post-wedding follow-up services'],
  }
};

const MyBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('venue');

  // ── Cancel request form states ──
  const [showCancelForm, setShowCancelForm] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [refundBankName, setRefundBankName] = useState('');
  const [refundAccountHolder, setRefundAccountHolder] = useState('');
  const [refundAccountNumber, setRefundAccountNumber] = useState('');
  const [cancelLoading, setCancelLoading] = useState(false);

  // ── NEW: loading state for View Details action button (same pattern as VenueCardsSection) ──
  const [detailLoadingId, setDetailLoadingId] = useState(null);

  const { baseUrl } = useContext(AppContext);
  const navigate = useNavigate();
  const loggedInCustomer = JSON.parse(localStorage.getItem('loggedInCustomer'));

  const viewMyBookings = () => {
    const formData = new FormData();
    formData.append('wecustomer_id', loggedInCustomer.id);
    axios.post(`${baseUrl}/customer/bookings/viewMyBookings`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      if (res.data.success === true) setBookings(res.data.bookings);
      setPageLoading(false);
    })
    .catch((err) => { console.log(err); setPageLoading(false); });
  };

  // ✅ NEW: Event column ab naye `eventType` field se aata hai (Event Type + Guest
  // Count screen se). Purani bookings jo My Event ke zamane mein bani thi, un ke liye
  // `weevent?.eventName` fallback rakha hai taake purana data bhi khaali na dikhe.
  const getEventDisplay = (booking) => booking.eventType || booking.weevent?.eventName || '—';

  // ✅ FIX: package-based booking mein wevenue_id hamesha NULL hota hai (sirf
  // wepackage_id bharta hai), lekin package khud ek venue se linked hoti hai —
  // isliye package.wevenue tak fallback karna zaroori hai warna venue name
  // hamesha khaali dikhta tha package bookings ke liye.
  const getVenueDisplay = (booking) =>
    booking.venue_name || booking.wevenue?.venueName || booking.wepackage?.wevenue?.venueName || '—';

  // Purana direct-cancel function hata kar cancel FORM kholne wala function
  const openCancelForm = () => {
    setCancelReason('');
    setRefundBankName('');
    setRefundAccountHolder('');
    setRefundAccountNumber('');
    setShowCancelForm(true);
  };

  // 3) onClick pe trigger, 4/5/6) FormData + API + then/catch
  const submitCancelRequest = () => {
    if (!cancelReason || !refundBankName || !refundAccountHolder || !refundAccountNumber) {
      Swal.fire({ icon: 'warning', title: 'Missing Info', text: 'Please fill reason and bank details.', confirmButtonColor: '#7fd3c1' });
      return;
    }

    setCancelLoading(true);
    const formData = new FormData();
    formData.append('id', selectedBooking.id);
    formData.append('cancelReason', cancelReason);
    formData.append('refundBankName', refundBankName);
    formData.append('refundAccountHolder', refundAccountHolder);
    formData.append('refundAccountNumber', refundAccountNumber);

    axios.post(`${baseUrl}/customer/bookings/cancelBooking`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      if (res.data.success === true) {
        setBookings(prev => prev.map(b => b.id === selectedBooking.id ? { ...b, status: 'cancelled' } : b));
        setShowCancelForm(false);
        setShowDetailModal(false);
        Swal.fire({ icon: 'success', title: 'Cancel Request Sent', text: res.data.message, confirmButtonColor: '#7fd3c1', timer: 3000, showConfirmButton: false });
      } else {
        Swal.fire({ icon: 'error', title: 'Cannot Cancel', text: res.data.message, confirmButtonColor: '#7fd3c1' });
      }
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Kuch ghalat ho gaya, dobara try karein.', confirmButtonColor: '#7fd3c1' });
    })
    .finally(() => setCancelLoading(false));
  };

 useEffect(() => {
  if (!loggedInCustomer) {
    navigate('/customer/login');
    return;
  }
  viewMyBookings();
}, []);

  const stats = {
    total: bookings.length,
    confirmed: bookings.filter(b => b.status === 'approved').length,
    pending: bookings.filter(b => b.status === 'pending').length,
    cancelled: bookings.filter(b => b.status === 'cancelled').length,
  };

  const filteredBookings = bookings.filter(b => {
    if (activeFilter === 'venue')
      return (b.wevenue_id !== null && b.wevenue_id !== '') && (b.wepackage_id === null || b.wepackage_id === '');
    if (activeFilter === 'package')
      return b.wepackage_id !== null && b.wepackage_id !== '';
    return true;
  });

  // ── UPDATED: View Details ab loading dikhata hai phir modal khulta hai ──
  const handleViewDetails = (booking) => {
    setDetailLoadingId(booking.id);
    setTimeout(() => {
      setSelectedBooking(booking);
      setShowDetailModal(true);
      setDetailLoadingId(null);
    }, 600);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'approved': return <Badge bg="success" className="cbk-status-badge"><FaCheckCircle /> Confirmed</Badge>;
      case 'pending':  return <Badge bg="warning" className="cbk-status-badge"><FaClock /> Pending</Badge>;
      case 'cancelled':return <Badge bg="danger"  className="cbk-status-badge"><FaTimesCircle /> Cancelled</Badge>;
      default:         return <Badge bg="secondary" className="cbk-status-badge">{status}</Badge>;
    }
  };

  const getPkgData = (booking) => {
    const name = booking?.wepackage?.packageName;
    return packageDetails[name] || null;
  };

  const formatAmount = (val) => {
    if (!val) return '—';
    return 'PKR ' + Number(val).toLocaleString('en-PK');
  };

  return (
    <CustomerLayout>
    <div className="cbk-bookings-page">
      <Container fluid className="cbk-container">

        <div className="cbk-page-header">
          <h1 className="cbk-page-title"><FaCalendarAlt className="cbk-title-icon" />My Bookings</h1>
          <p className="cbk-page-subtitle">Manage your venue bookings and reservations</p>
        </div>

        <Row className="cbk-stats-row">
          <Col lg={3} md={6} sm={6} className="cbk-stat-col">
            <Card className="cbk-stat-card cbk-stat-total">
              <Card.Body>
                <div className="cbk-stat-icon"><FaCalendarAlt /></div>
                <div className="cbk-stat-info"><h3 className="cbk-stat-number">{stats.total}</h3><p className="cbk-stat-label">Total Bookings</p></div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={6} className="cbk-stat-col">
            <Card className="cbk-stat-card cbk-stat-confirmed">
              <Card.Body>
                <div className="cbk-stat-icon"><FaCheckCircle /></div>
                <div className="cbk-stat-info"><h3 className="cbk-stat-number">{stats.confirmed}</h3><p className="cbk-stat-label">Confirmed</p></div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={6} className="cbk-stat-col">
            <Card className="cbk-stat-card cbk-stat-pending">
              <Card.Body>
                <div className="cbk-stat-icon"><FaClock /></div>
                <div className="cbk-stat-info"><h3 className="cbk-stat-number">{stats.pending}</h3><p className="cbk-stat-label">Pending</p></div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} sm={6} className="cbk-stat-col">
            <Card className="cbk-stat-card cbk-stat-cancelled">
              <Card.Body>
                <div className="cbk-stat-icon"><FaTimesCircle /></div>
                <div className="cbk-stat-info"><h3 className="cbk-stat-number">{stats.cancelled}</h3><p className="cbk-stat-label">Cancelled</p></div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Card className="cbk-section-card">
          <Card.Header className="cbk-card-header">
            <h3 className="cbk-section-title"><FaCalendarAlt className="cbk-section-icon" />My Bookings List</h3>
            <div className="cbk-filter-btns">
              <button className={`cbk-filter-btn cbk-filter-btn--venue ${activeFilter === 'venue' ? 'cbk-filter-btn--active' : ''}`} onClick={() => setActiveFilter('venue')}>
                <FaBuilding className="me-1" /> Venue
              </button>
              <button className={`cbk-filter-btn cbk-filter-btn--package ${activeFilter === 'package' ? 'cbk-filter-btn--active' : ''}`} onClick={() => setActiveFilter('package')}>
                <FaBox className="me-1" /> Package
              </button>
            </div>
            <Badge bg="primary" className="cbk-count-badge">{filteredBookings.length} Total</Badge>
          </Card.Header>
          <Card.Body className="cbk-card-body">
            <div className="cbk-table-wrapper">
              {pageLoading ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Loading...
                </div>
              ) : (
                <Table responsive hover className="cbk-table">
                  <thead>
                    <tr>
                      <th>Booking ID</th>
                      <th>Event</th>
                      {activeFilter === 'venue'   && <th>Venue</th>}
                      {activeFilter === 'package' && <th>Package</th>}
                      <th>Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBookings.length === 0 && (
                      <tr><td colSpan={6} style={{ textAlign: "center", padding: "40px 0" }}>No bookings found</td></tr>
                    )}
                    {filteredBookings.map((booking) => (
                      <tr key={booking.id}>
                        <td className="cbk-booking-id">BK-{booking.id}</td>
                        <td style={{ textTransform: 'capitalize' }}>{getEventDisplay(booking)}</td>
                        {activeFilter === 'venue'   && <td>{getVenueDisplay(booking)}</td>}
                        {activeFilter === 'package' && <td>{booking.wepackage?.packageName || '—'}</td>}
                        <td>{booking.date}</td>
                        <td>{getStatusBadge(booking.status)}</td>
                        <td>
                          <Button className="cbk-btn-action cbk-btn-details" onClick={() => handleViewDetails(booking)}
                            disabled={detailLoadingId === booking.id}
                            style={{ width: '40px', height: '40px', padding: '0', fontSize: '16px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px' }}>
                            {detailLoadingId === booking.id ? (
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            ) : (
                              <FaEye />
                            )}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>

      </Container>

      {/* ===================== BOOKING DETAIL MODAL ===================== */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered className="cbk-modal">
        <Modal.Header closeButton className="cbk-modal-header">
          <Modal.Title className="cbk-modal-title">
            <FaEye className="cbk-modal-icon" />Booking Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="cbk-modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          {selectedBooking && (() => {
            const pkgData = getPkgData(selectedBooking);
            return (
              <div>
                {/* ── Basic Info ── */}
                <div className="cbk-detail-view" style={{ marginBottom: '25px' }}>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Booking ID:</span>
                    <span className="cbk-detail-value">BK-{selectedBooking.id}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Event:</span>
                    <span className="cbk-detail-value" style={{ textTransform: 'capitalize' }}>{getEventDisplay(selectedBooking)}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Guest Count:</span>
                    <span className="cbk-detail-value">{selectedBooking.guestCount || '—'}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Venue:</span>
                    <span className="cbk-detail-value">{getVenueDisplay(selectedBooking)}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Package:</span>
                    <span className="cbk-detail-value">{selectedBooking.wepackage?.packageName || '—'}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Date:</span>
                    <span className="cbk-detail-value">{selectedBooking.date}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Total Amount:</span>
                    <span className="cbk-detail-value">{formatAmount(selectedBooking.totalAmount)}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Advance Paid:</span>
                    <span className="cbk-detail-value">{formatAmount(selectedBooking.advanceAmount)}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Remaining:</span>
                    <span className="cbk-detail-value">{formatAmount(selectedBooking.remainingAmount)}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Payment Status:</span>
                    <span className="cbk-detail-value" style={{ textTransform: 'capitalize' }}>{selectedBooking.paymentStatus || 'unpaid'}</span>
                  </div>
                  <div className="cbk-detail-item">
                    <span className="cbk-detail-label">Status:</span>
                    {getStatusBadge(selectedBooking.status)}
                  </div>
                </div>

                {/* ── Package Detail Section (only if package booking) ── */}
                {pkgData && (
                  <>
                    <div className="pkgd-content-card" style={{ marginBottom: '20px' }}>
                      <div className="card-body" style={{ padding: '25px' }}>
                        <h4 className="pkgd-section-title">About This Package</h4>
                        <p className="pkgd-description">{pkgData.description}</p>
                        <div className="pkgd-package-meta" style={{ marginTop: '10px' }}>
                          <div className="pkgd-meta-item"><FaMapMarkerAlt className="pkgd-meta-icon" /><span>{pkgData.venue.name} — {pkgData.venue.location}</span></div>
                          <div className="pkgd-meta-item"><FaUsers className="pkgd-meta-icon" /><span>Capacity: {pkgData.venue.capacity}</span></div>
                        </div>
                      </div>
                    </div>

                    <div className="pkgd-content-card pkgd-venue-amenities-card" style={{ marginBottom: '20px' }}>
                      <div className="card-body" style={{ padding: '25px' }}>
                        <h4 className="pkgd-section-title">Venue & Amenities</h4>
                        <div className="pkgd-venue-header">
                          <div className="pkgd-venue-icon-wrap"><FaBuilding /></div>
                          <div>
                            <h6 className="pkgd-venue-name">{pkgData.venue.name}</h6>
                            <p className="pkgd-venue-loc"><FaMapMarkerAlt className="me-1" />{pkgData.venue.location}</p>
                          </div>
                        </div>
                        <p className="pkgd-venue-desc">{pkgData.venue.description}</p>
                        <hr className="pkgd-divider" />
                        <div className="pkgd-venue-info-grid">
                          <div className="pkgd-venue-info-item"><FaBuilding className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Venue Type</span><span className="pkgd-vi-value">{pkgData.venue.type}</span></div></div>
                          <div className="pkgd-venue-info-item"><FaUsers className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Capacity</span><span className="pkgd-vi-value">{pkgData.venue.capacity}</span></div></div>
                          <div className="pkgd-venue-info-item"><FaParking className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Parking</span><span className="pkgd-vi-value">{pkgData.venue.parking}</span></div></div>
                          <div className="pkgd-venue-info-item"><FaBed className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Rooms</span><span className="pkgd-vi-value">{pkgData.venue.rooms}</span></div></div>
                          <div className="pkgd-venue-info-item"><FaTree className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Outdoor</span><span className="pkgd-vi-value">{pkgData.venue.garden}</span></div></div>
                          <div className="pkgd-venue-info-item"><FaGlassCheers className="pkgd-vi-icon" /><div><span className="pkgd-vi-label">Halls</span><span className="pkgd-vi-value">{pkgData.venue.floors}</span></div></div>
                        </div>
                        <hr className="pkgd-divider" />
                        <h6 className="pkgd-amenities-section-title">Amenities</h6>
                        <div className="pkgd-amenities-text-grid">
                          {pkgData.amenities.map((amenity, i) => (
                            <div key={i} className="pkgd-amenity-text-item">
                              <FaCheckCircle className="pkgd-amenity-check-icon" /><span>{amenity}</span>
                            </div>
                          ))}
                        </div>
                        <hr className="pkgd-divider" />
                        <div className="pkgd-venue-contact">
                          <div className="pkgd-contact-item"><FaPhone className="pkgd-contact-icon" /><span>{pkgData.venue.phone}</span></div>
                          <div className="pkgd-contact-item"><FaEnvelope className="pkgd-contact-icon" /><span>{pkgData.venue.email}</span></div>
                        </div>
                      </div>
                    </div>

                    <div className="pkgd-content-card" style={{ marginBottom: '20px' }}>
                      <div className="card-body" style={{ padding: '25px' }}>
                        <h4 className="pkgd-section-title">Included Services</h4>
                        <Row className="pkgd-services-grid">
                          {pkgData.includedServices.map((service, i) => (
                            <Col md={6} key={i} className="pkgd-service-col">
                              <div className="pkgd-service-item">
                                <div className="pkgd-service-icon-wrapper"><FaCheckCircle /></div>
                                <div className="pkgd-service-content">
                                  <h6 className="pkgd-service-title">{service.title}</h6>
                                  <p className="pkgd-service-desc">{service.description}</p>
                                </div>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>

                    <div className="pkgd-content-card" style={{ marginBottom: '20px' }}>
                      <div className="card-body" style={{ padding: '25px' }}>
                        <h4 className="pkgd-section-title">Package Features</h4>
                        <Row>
                          {pkgData.features.map((feature, i) => (
                            <Col md={6} key={i} className="pkgd-feature-col">
                              <div className="pkgd-feature-item">
                                <FaCheckCircle className="pkgd-check-icon" /><span>{feature}</span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>

                    <div className="pkgd-content-card" style={{ marginBottom: '20px' }}>
                      <div className="card-body" style={{ padding: '25px' }}>
                        <h4 className="pkgd-section-title">Venue Highlights</h4>
                        <ul className="pkgd-sidebar-highlights-list">
                          {pkgData.venue.highlights.map((h, i) => (
                            <li key={i} className="pkgd-sidebar-highlight-item">
                              <FaCheckCircle className="pkgd-sidebar-highlight-icon" /><span>{h}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </>
                )}

                {/* Cancel Button — sirf pending/approved status pe, aur cancel form nahi khula ho */}
                {selectedBooking.status !== 'cancelled' && !showCancelForm && (
                  <div className="cbk-modal-actions">
                    <Button className="cbk-btn cbk-btn-cancel" onClick={openCancelForm}>
                      <FaBan className="me-2" />Cancel Booking
                    </Button>
                  </div>
                )}

                {/* ── Cancel Request Form ── */}
                {showCancelForm && (
                  <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #f3d1d1', borderRadius: '10px', background: '#fff8f8' }}>
                    <h5 style={{ marginBottom: '15px' }}>Cancel Request Details</h5>
                    <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '15px' }}>
                      Note: Cancellation booking create hone ke 3 din ke andar hi allowed hai.
                    </p>

                    <Form.Group className="mb-3">
                      <Form.Label>Reason for Cancellation</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={cancelReason}
                        onChange={(e) => setCancelReason(e.target.value)}
                        placeholder="Cancel karne ki wajah likhein..."
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Bank Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={refundBankName}
                        onChange={(e) => setRefundBankName(e.target.value)}
                        placeholder="e.g. HBL, UBL, Meezan..."
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Account Holder Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={refundAccountHolder}
                        onChange={(e) => setRefundAccountHolder(e.target.value)}
                        placeholder="Account holder ka poora naam"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Account Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={refundAccountNumber}
                        onChange={(e) => setRefundAccountNumber(e.target.value)}
                        placeholder="Bank account number"
                      />
                    </Form.Group>

                    <div style={{ display: 'flex', gap: '10px' }}>
                      <Button className="cbk-btn cbk-btn-cancel" disabled={cancelLoading} onClick={submitCancelRequest}>
                        {cancelLoading ? 'Submitting...' : 'Submit Cancel Request'}
                      </Button>
                      <Button variant="secondary" onClick={() => setShowCancelForm(false)}>
                        Back
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
        </Modal.Body>
      </Modal>
    </div>
    </CustomerLayout>
  );
};

export default MyBookings;